import DailyData from '@/components/analyticsPage/tabPanels/components/drawers/dataDrawer/components/esgDataTab/components/dailyData/DailyData';
import TimeSeries from '@/components/analyticsPage/tabPanels/components/drawers/dataDrawer/components/esgDataTab/components/timeSeries/TimeSeries';
import DrawerInput from '@/components/analyticsPage/input/DrawerInput';
import { useDataQuery } from '@/components/analyticsPage/tabPanels/components/drawers/dataDrawer/hooks/useDataQuery';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

const ESGdataTab = () => {
  const [t] = useTranslation('analytics');

  const [setQuery] = useDataQuery();
  const tab = useSelector((state: any) => state.analytics.dataQuery);
  const handleTabChange = (target: string) => {
    setQuery({ target });
  };

  return (
    <div className="space-y-4">
      <DrawerInput data={tab} setQuery={setQuery} />
      <Tabs defaultValue="dailyData" value={tab.target} onValueChange={handleTabChange}>
        <TabsList className="w-full my-4">
          <TabsTrigger value="dailyData" className="w-full">
            {t('Daily data')}
          </TabsTrigger>
          <TabsTrigger value="timeSeries" className="w-full">
            {t('Time series data')}
          </TabsTrigger>
        </TabsList>
        <TabsContent value="dailyData">
          <DailyData />
        </TabsContent>
        <TabsContent value="timeSeries">
          <TimeSeries />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default ESGdataTab;
